import React, { useRef } from "react";
import { getMathJaxNode } from "../../mathjax/MathJax";

const Process = ( props ) => {

  const inlineBlockCont = useRef();
  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const changedDataCount = props.data.filter( ( v, i ) => prevData.current[ i ] !== v ).length;

  const MathJaxNode = getMathJaxNode( props.type );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = props.data;
      mathjaxRenderCount.current = 0;
      props.onRender( inlineBlockCont.current.offsetWidth, props.index );
    }
  };

  return (
    <div className="inlineblock_cont" style={ { marginTop : 20 * props.index } } ref={ inlineBlockCont }>
      <table className="tbl-htreeD tree_chain">
        <tbody>
        <tr>
          <td className="d-up pl-1"><span className="diagonal"><span className="line" /></span></td>
          <td className="pb-1"><span className="inputTxt"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 0 ] || '' }</MathJaxNode></span></td>
        </tr>
        <tr>
          <td className="d-down pl-1"><span className="diagonal"><span className="line" /></span></td>
          <td className="pt-1"><span className="inputTxt"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 1 ] || '' }</MathJaxNode></span></td>
        </tr>
        </tbody>
      </table>
    </div>
  );

};

export default Process;
